import { Component, OnInit } from '@angular/core';
import { APICallService } from 'src/app/services/api-call.service';
import { FormBuilder, Validators, FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { DatePipe } from '@angular/common';
import { DialogMsgComponent } from '../../common/dialog-msg/dialog-msg.component';
import { FormService } from 'src/app/services/form.service';
import { JsonDataService } from 'src/app/services/json-data.service';
import { AppMessageService } from 'src/app/services/app-message.service';
import { UserDetailsService } from 'src/app/services/user-details.service';
import { forkJoin, Observable } from 'rxjs';
import { LeaveConfirmation } from '../../common/guard/check.guard';
import { SecurityService } from 'src/app/services/security.service'; 
@Component({
  selector: 'construction-year-maintenance',
  templateUrl: './construction-year-maintenance.component.html',
  styleUrls: ['./construction-year-maintenance.component.css']
})
export class ConstructionYearMaintenanceComponent implements OnInit, LeaveConfirmation {
  
  datePipe = new DatePipe('en-us');

  addDisabled : boolean = false;
  saveDisabled : boolean = true;
  deleteDisabled : boolean = true;
  tranPosted : boolean = false;
  noLoadingInProcess : boolean = true;
  validated : boolean = false;
  userIDReadOnly : boolean = false;
  isLineSelected : boolean = false;
  pubUserStdRatesCodeField: string = '';
  currentUser: string = this.jsonDataService.retrieveFromStorage('userId');
  rowClickedData: any;
  selectedData : any = null;
  moduleId: string = 'BMM183';
  perilDisabled: boolean = true;
  moduleName: string = '';
  tempAddedData: any = [];
  tempUpdateData: any = [];

  constructionYearForm = this.formBuilder.group({
    yearBuiltCode: [null, [Validators.required]],
    activeTag: ['A', [Validators.required]],
    yearBuiltDesc: [null, [Validators.required, Validators.maxLength(500)]],
    yearBuiltFrom: [null, [Validators.required]],
    yearBuiltTo: [null, [Validators.required]],
    bpimsCode: [null, [Validators.required, Validators.maxLength(8)]],
    remarks: [null, [Validators.maxLength(1000)]],
    userID: [null],
    lastUserUpdate: [null]
  });

  constructor(
    private apiCallService: APICallService,
    public _Dialog: MatDialog, 
    private userDetailService: UserDetailsService,
    private formService: FormService, 
    private formBuilder: FormBuilder, 
    private appMessageService: AppMessageService,
    private jsonDataService: JsonDataService,
    private securityService: SecurityService
  ) {
    let moduleLists = JSON.parse(this.jsonDataService.decrypt(sessionStorage.getItem("mdls") || "")); 
    this.moduleName = moduleLists.filter((data: any) => { return data.moduleId === this.moduleId })[0].moduleDesc.toUpperCase();
  }

  canDeactivate(): Observable<boolean> | boolean {
    if(this.tempAddedData!='' || this.tempUpdateData!='') {
      return false;
    } else {
      return true;
    }
  }

  constructionYearTblConfig: any = {
    cols: [
      {
        key: "YEAR_BUILT_CD",
        header: "Year Built Code",
        dataType: "number"
      },
      {
        key: "YEAR_BUILT_DESC",
        header: "Construction Description",
        dataType: "string"
      },
      {
        key: "YEAR_BUILT_FROM",
        header: "Year Built From",
        dataType: "string"
      },
      {
        key: "YEAR_BUILT_TO",
        header: "Year Built To",
        dataType: "string"
      },
      {
        key: "ACTIVE_TAG",
        header: "A",
        dataType: "checkbox",
        width: '10%'
      }
    ],
    tblData: [],
    selection: "single",
    paginator: true,
    rowsPerPage: 10,
    lazy: false,
    totalRecords: 15,
    loading: false,
  }
  ngOnInit() {
    try {
      this.apiCallService.refreshNeeded$
            .subscribe(() => {
              this.getAllSegmentCode();
          });
      this.getAllSegmentCode();
    }
    catch(e) {
    }
  }

  async getAllSegmentCode(){
    try{
      const params = {
        moduleId: this.moduleId,
        userId: this.userDetailService.userId,
        type: "MODULE"
      }
      this.constructionYearTblConfig.loading = true;
      this.apiCallService.getConstructionYear(params).subscribe({
        next: (data: any) => {
          this.securityService.checkRequestKeyResponse(data, ()=>{
            this.securityService.hasValidCsrfToken(data, ()=>{
              if (data.status === "SUCCESS") {
                let content = JSON.parse(this.jsonDataService.decrypt(data?.response));
                this.constructionYearTblConfig.tblData = content.data;
                this.constructionYearTblConfig.loading = false;
              }
              else {
                this.jsonDataService.contorlLoading(false);
                this.constructionYearTblConfig.loading = false;
              }
            });
          })
        },
        error: (e: any) => {
          this.constructionYearTblConfig.loading = false;
        }
      });
    }catch(e){
    }
  }

  updateLine() {
    try {
      this.tranPosted = true;
      this.validateUpdate();
      if (this.validated) {
        this.updateFormTable();
      }
    }
    catch(e) {
    }
  }

  updateFormTable() {
    try {
      let tempInsertChecker = this.tempAddedData.find((line: { YEAR_BUILT_FROM: any }) => 
        +line.YEAR_BUILT_FROM == +this.constructionYearForm.get('yearBuiltFrom')?.value
      );
      let tempUpdateChecker = this.tempUpdateData.find((line: { YEAR_BUILT_FROM: any }) => 
        +line.YEAR_BUILT_FROM == +this.constructionYearForm.get('yearBuiltFrom')?.value
      );
      
      this.tableDataUpdate();
        
      // Adds Updated Data that exists in the database to an object array for updated datas
      if(tempInsertChecker!=null && tempInsertChecker!='') {
        //this.tempUpdateData.push(this.formValueToData());
        tempInsertChecker.YEAR_BUILT_CD = this.constructionYearForm.get('yearBuiltCode')?.value;
        tempInsertChecker.ACTIVE_TAG = this.constructionYearForm.get('activeTag')?.value;
        tempInsertChecker.YEAR_BUILT_DESC = this.constructionYearForm.get('yearBuiltDesc')?.value;
        tempInsertChecker.YEAR_BUILT_FROM = +this.constructionYearForm.get('yearBuiltFrom')?.value;
        tempInsertChecker.YEAR_BUILT_TO = +this.constructionYearForm.get('yearBuiltTo')?.value;
        tempInsertChecker.BM_CODE = this.constructionYearForm.get('bpimsCode')?.value;
        tempInsertChecker.REMARKS = this.constructionYearForm.get('remarks')?.value;
        tempInsertChecker.LAST_USER_UPDATE = this.datePipe.transform(new Date(this.constructionYearForm.get('lastUserUpdate')?.value), 'MM/dd/YYYY h:mm:ss a');
        tempInsertChecker.USER_ID = this.constructionYearForm.get('userID')?.value;
        tempInsertChecker.MODE = 'I';
      } 
      else if(tempUpdateChecker!=null && tempUpdateChecker!='') {
        tempUpdateChecker.YEAR_BUILT_CD  = this.constructionYearForm.get('yearBuiltCode')?.value;
        tempUpdateChecker.ACTIVE_TAG = this.constructionYearForm.get('activeTag')?.value;
        tempUpdateChecker.YEAR_BUILT_DESC = this.constructionYearForm.get('yearBuiltDesc')?.value;
        tempUpdateChecker.YEAR_BUILT_FROM = +this.constructionYearForm.get('yearBuiltFrom')?.value;
        tempUpdateChecker.YEAR_BUILT_TO = +this.constructionYearForm.get('yearBuiltTo')?.value;
        tempUpdateChecker.BM_CODE = this.constructionYearForm.get('bpimsCode')?.value;
        tempUpdateChecker.REMARKS = this.constructionYearForm.get('remarks')?.value;
        tempUpdateChecker.LAST_USER_UPDATE = this.datePipe.transform(new Date(this.constructionYearForm.get('lastUserUpdate')?.value), 'MM/dd/YYYY h:mm:ss a');
        tempUpdateChecker.USER_ID = this.constructionYearForm.get('userID')?.value;
        tempUpdateChecker.MODE = 'U';
      }
      else {
        this.tempUpdateData.push(this.formValueToData());
      }
      this.saveDisabled = false;
      this.resetFormValues();
      this.appMessageService.showAppMessage("Construction Year details updated!", "success");
    }
    catch(e) {
    }
  }

  tableDataUpdate() {
    try {
      this.constructionYearForm.patchValue({
        activeTag: this.constructionYearForm.get('activeTag')?.value,
        userID: this.currentUser,
        lastUserUpdate: new Date()
      });
      let updateIndex = this.constructionYearTblConfig.tblData.indexOf(this.rowClickedData);
      
      this.constructionYearTblConfig.tblData[updateIndex] = {
        YEAR_BUILT_CD: this.constructionYearForm.get('yearBuiltCode')?.value,
        ACTIVE_TAG: this.constructionYearForm.get('activeTag')?.value,
        YEAR_BUILT_DESC: this.constructionYearForm.get('yearBuiltDesc')?.value,
        YEAR_BUILT_FROM: +this.constructionYearForm.get('yearBuiltFrom')?.value,
        YEAR_BUILT_TO: +this.constructionYearForm.get('yearBuiltTo')?.value,
        BM_CODE: this.constructionYearForm.get('bpimsCode')?.value,
        REMARKS: this.constructionYearForm.get('remarks')?.value,
        LAST_USER_UPDATE: this.datePipe.transform(new Date(this.constructionYearForm.get('lastUserUpdate')?.value), 'MM/dd/YYYY h:mm:ss a'),
        USER_ID: this.constructionYearForm.get('userID')?.value,
        MODE: 'U'
      };
      this.constructionYearTblConfig.tblData = [...this.constructionYearTblConfig.tblData];
    }
    catch(e) {
    }
  }

  formValueToData() {
    try {
      let formToData: any = { // this.datePipe.transform(new Date(), 'MM/dd/yyyy')
        YEAR_BUILT_CD: this.constructionYearForm.get('yearBuiltCode')?.value,
        ACTIVE_TAG: this.constructionYearForm.get('activeTag')?.value,
        YEAR_BUILT_DESC: this.constructionYearForm.get('yearBuiltDesc')?.value,
        YEAR_BUILT_FROM: this.constructionYearForm.get('yearBuiltFrom')?.value,
        YEAR_BUILT_TO: this.constructionYearForm.get('yearBuiltTo')?.value,
        BM_CODE: this.constructionYearForm.get('bpimsCode')?.value,
        REMARKS: this.constructionYearForm.get('remarks')?.value,
        LAST_USER_UPDATE: this.datePipe.transform(new Date(this.constructionYearForm.get('lastUserUpdate')?.value), 'MM/dd/YYYY h:mm:ss a'),
        USER_ID: this.constructionYearForm.get('userID')?.value,
        MODE: 'U'
      }
      return formToData;
    }
    catch(e) {
    }
  }
  deleteLine() {
    try {
      let clickData = this.rowClickedData;
      this.constructionYearTblConfig.tblData = this.constructionYearTblConfig.tblData.filter(
        function(e: any) {
          return +e.YEAR_BUILT_FROM !== +clickData.YEAR_BUILT_FROM;
        }
      );
      this.tempAddedData = this.tempAddedData.filter(
        function(e: any) {

          return +e.YEAR_BUILT_FROM !== +clickData.YEAR_BUILT_FROM;
        }
      );
      this.resetFormValues();
    }
    catch(e) {
    }
  }

  insertLine() {
    try {
      this.tranPosted = true;
      this.validateInsert();
      if (this.validated) {
        this.addFormToTable();
      }
    }
    catch(e) {
    }
  }
  addFormToTable() {
    try {
      this.constructionYearForm.patchValue({
        activeTag: this.constructionYearForm.get('activeTag')?.value,
        userID: this.currentUser,
        lastUserUpdate: new Date()
      });
      let formToData: any = { // this.datePipe.transform(new Date(), 'MM/dd/yyyy')
        YEAR_BUILT_CD: this.constructionYearForm.get('yearBuiltCode')?.value,
        YEAR_BUILT_DESC: this.constructionYearForm.get('yearBuiltDesc')?.value,
        YEAR_BUILT_FROM: +this.constructionYearForm.get('yearBuiltFrom')?.value,
        YEAR_BUILT_TO: +this.constructionYearForm.get('yearBuiltTo')?.value,
        ACTIVE_TAG: this.constructionYearForm.get('activeTag')?.value,
        BM_CODE: this.constructionYearForm.get('bpimsCode')?.value,
        REMARKS: this.constructionYearForm.get('remarks')?.value,
        LAST_USER_UPDATE: this.datePipe.transform(new Date(this.constructionYearForm.get('lastUserUpdate')?.value), 'MM/dd/YYYY h:mm:ss a'),
        USER_ID: this.constructionYearForm.get('userID')?.value,
        MODE: 'I'
      }
      this.constructionYearTblConfig.tblData.unshift(formToData);
      this.constructionYearTblConfig.tblData = [...this.constructionYearTblConfig.tblData];
      this.tempAddedData.push(formToData);
      this.resetFormValues();
      this.appMessageService.showAppMessage("Construction Year details added!", "success");
    }
    catch(e) {
    }
  }

  saveData(tempChangeData:any[]){
    this.apiCallService.saveConstructionYear(tempChangeData)
    .subscribe({
      next: (response : any) => {
        this.securityService.checkRequestKeyResponse(response, () => {
          this.securityService.hasValidCsrfToken(response, ()=>{
            if (response.status == "SUCCESS" && this.tranPosted) {
              this.openDialog('SUCCESS', 'Details Successfully saved!');
              this.getAllSegmentCode();
              this.resetFormValues();
              this.tempAddedData = [];
              this.tempUpdateData = [];
              this.saveDisabled = this.saveChecker();
            }  
            else {
              this.getAllSegmentCode();
              this.saveDisabled = this.saveChecker();
              this.openDialog('ERROR', 'An error has occured while saving details');
            }
          });
        });
      }, 
      error: () => {
        this.openDialog('ERROR', 'An error has occured while saving details');
      }
    });
  }

  toSave() {
    try {
      this.noLoadingInProcess = false;
      this.formService.showFormLoader(null, "generate-line-form", "Please wait ...", null, null);
      let tempChangeData= this.tempAddedData.concat(this.tempUpdateData);
      if(tempChangeData.length!=0) {
        for(let item of tempChangeData){
          item.YEAR_BUILT_FROM = item.YEAR_BUILT_FROM.toString();
          item.YEAR_BUILT_TO = item.YEAR_BUILT_TO.toString();
        }
        this.saveData(tempChangeData);
      } else {
        this.getAllSegmentCode();
        this.resetFormValues();
        this.tempAddedData = [];
        this.tempUpdateData = [];
        this.saveDisabled = this.saveChecker();
      }
    }
    catch(e) {
    }
  }
  saveChecker() {
    try {
      if((this.tempAddedData==null || this.tempAddedData=='') && (this.tempUpdateData==null || this.tempUpdateData=='')) {
        return true;
      }
      else {
        return false;
      }
    }
    catch(e) {
      return true;
    }
  }

  deleteChecker(ev: any) {
    try {
      let tempDataFlag;
      tempDataFlag = this.tempAddedData.filter(function(e: any) {
        return +e.YEAR_BUILT_FROM==+ev.YEAR_BUILT_FROM;
        
      });
      if(tempDataFlag==''||tempDataFlag==null) {
        return true;
      } else {
        return false;
      }
    }
    catch(e) {
      return true;
    }
  }

  onRowClick(ev: any) {
    try {    
      if(ev!=null) {
        this.rowClickedData = ev;
        this.loadFormValues();
        this.saveDisabled = this.saveChecker();
        this.deleteDisabled = this.deleteChecker(ev);
      }
      else {
        this.resetFormValues();
      }
    }
    catch(e) {
    }
  }

  loadFormValues() {
    try {
      this.constructionYearForm.patchValue({
        yearBuiltCode: this.rowClickedData.YEAR_BUILT_CD,
        activeTag: this.rowClickedData.ACTIVE_TAG,
        yearBuiltDesc: this.rowClickedData.YEAR_BUILT_DESC,
        yearBuiltFrom: this.rowClickedData.YEAR_BUILT_FROM,
        yearBuiltTo: this.rowClickedData.YEAR_BUILT_TO,
        bpimsCode: this.rowClickedData.BM_CODE,
        remarks: this.rowClickedData.REMARKS,
        userID: this.rowClickedData.USER_ID,
        lastUserUpdate: this.rowClickedData.LAST_USER_UPDATE
      });
      this.addDisabled = true;
      this.userIDReadOnly = true;
      this.isLineSelected = true;
    }
    catch(e) {
    }
  }

  resetFormValues() {
    try {
      this.selectedData = null;
      // this.paramForm.get('lineCD')?.enable();
      this.constructionYearForm.patchValue({
        yearBuiltCode: null,
        activeTag: 'A',
        yearBuiltDesc: null,
        yearBuiltFrom: null,
        yearBuiltTo: null,
        bpimsCode: null,
        remarks: null,
        userID: null,
        lastUserUpdate: null
      });

      this.addDisabled = false;
      this.saveDisabled = this.saveChecker();
      this.deleteDisabled = true;
      this.userIDReadOnly = false;
      this.isLineSelected = false;

      this.rowClickedData = '' || null;
    }
    catch (e) {
    console.error(e);
    }
  }

  openDialog(title: any, message: any) {
    try {
      this.noLoadingInProcess = true;
      this.formService.hideFormLoader("generate-line-form");
      this._Dialog.open(DialogMsgComponent, { 
        disableClose: true,
        width: "500px",
        data: {
          title: title,
          content: message
        } 
      });
    } catch(e) {
    }
  }

  validateInsert() {
    try {
      this.validated = false;
      if (!this.requiredFieldCheck()){
        setTimeout(()=>{                           //10 secs countdown
          this.formService.hideFormMsg("construction-year-error-message");
        }, 10000);
      }
      else if (!this.duplicateCheck(this.constructionYearTblConfig.tblData)) {
        setTimeout(()=>{                           
          this.formService.hideFormMsg("construction-year-error-message");
        }, 10000);
      }
      else if (this.yearBuiltToCheck()) {
        setTimeout(()=>{                           
          this.formService.hideFormMsg("construction-year-error-message");
        }, 10000);
      }
      else {
        this.validated = true;
      }
    }
    catch (e) {
    console.error(e);
    }
  }

  validateUpdate() {
    try {
      this.validated = false;
      let fieldYearBuiltFrom = parseInt(this.constructionYearForm.get('yearBuiltFrom')?.value);
      let filteredTblData = this.constructionYearTblConfig.tblData.filter(function(e:any){
        let eYearBuiltFrom = parseInt(e.YEAR_BUILT_FROM);
        if(fieldYearBuiltFrom!==eYearBuiltFrom){
          return true;
        }
        else{
          return false;
        }
      });
      if (!this.requiredFieldCheck()){
        setTimeout(()=>{                          
          this.formService.hideFormMsg("construction-year-error-message");
        }, 10000);
      }
      else if (!this.duplicateCheck(filteredTblData)) {
        setTimeout(()=>{                           
          this.formService.hideFormMsg("construction-year-error-message");
        }, 10000);
      }
      else if (this.yearBuiltToCheck()) {
        setTimeout(()=>{                           
          this.formService.hideFormMsg("construction-year-error-message");
        }, 10000);
      }
      else {
        this.validated = true;
      }
    }
    catch (e) {
    console.error(e);
    }
  }

  requiredFieldCheck() {
    try {
      if(this.constructionYearForm.get('activeTag')?.value==='' || this.constructionYearForm.get('activeTag')?.value===null 
        || this.constructionYearForm.get('yearBuiltDesc')?.value.trim()==='' || this.constructionYearForm.get('yearBuiltDesc')?.value===null
        || this.constructionYearForm.get('yearBuiltFrom')?.value==='' || this.constructionYearForm.get('yearBuiltFrom')?.value===null
        || this.constructionYearForm.get('yearBuiltTo')?.value==='' || this.constructionYearForm.get('yearBuiltTo')?.value===null
        || this.constructionYearForm.get('bpimsCode')?.value===''||this.constructionYearForm.get('bpimsCode')?.value===null) {
        this.formService.showFormMsg("construction-year-error-message", 'There are missing information. Please provide the necessary information needed.', "E");
        return false;
      }
      else {
        return true;
      }
   }
    catch (e) {
    console.error(e);
      return false;
    }
  }

  // duplicateCheck(tblData:any) {
  //   try {
  //     let fieldConstructionDesc = this.constructionYearForm.get('yearBuiltDesc')?.value;
  //     this.pubUserStdRatesCodeField = tblData.filter(function(e: any) {
  //       if(e.YEAR_BUILT_DESC.trim().toUpperCase()==fieldConstructionDesc.trim().toUpperCase()){
  //         return true
  //       }
  //       else{
  //         return false
  //       }
  //     });
  //     if(this.pubUserStdRatesCodeField=='' || this.pubUserStdRatesCodeField==null) {
  //       return true;
  //     } else {
  //       this.formService.showFormMsg("construction-year-error-message", 'Construction Description already exists. Please add a unique Construction Description', "E");
  //       return false;
  //     }
  //   }
  //   catch (e) {
  //     return false;
  //   }
  // }

  duplicateCheck(tblData:any) {
    try {
      let fieldYearBuiltToValue = this.constructionYearForm.get('yearBuiltTo')?.value;
      let fieldYearBuiltFrom= parseInt(this.constructionYearForm.get('yearBuiltFrom')?.value);
      let fieldYearBuiltTo= parseInt(fieldYearBuiltToValue)
      this.pubUserStdRatesCodeField = tblData.filter(function(e: any) {
        let eYearBuiltFrom = parseInt(e.YEAR_BUILT_FROM);
        let eYearBuiltTo = parseInt(e.YEAR_BUILT_TO);

        if(fieldYearBuiltFrom>=eYearBuiltFrom&&fieldYearBuiltTo<=eYearBuiltTo){
            return true;
        }
        if(fieldYearBuiltFrom<=eYearBuiltFrom&&fieldYearBuiltTo>=eYearBuiltTo){
          return true;
        }
        if(fieldYearBuiltFrom<=eYearBuiltFrom&&fieldYearBuiltTo>=eYearBuiltFrom){
          return true;
        }
        if(fieldYearBuiltFrom<=eYearBuiltTo&&fieldYearBuiltTo>=eYearBuiltTo){
          return true;
        }
        return false;
      });
      if(this.pubUserStdRatesCodeField=='' || this.pubUserStdRatesCodeField==null) {
        return true;
      } else {
        this.formService.showFormMsg("construction-year-error-message", 'Year Built must not coincides with period of existing active records', "E");
        return false;
      }
    }
    catch (e) {
    console.error(e);
      return false;
    }
  }

  yearBuiltToCheck(){
    try{
      let fieldYearBuiltFrom= parseInt(this.constructionYearForm.get('yearBuiltFrom')?.value);
      if(this.constructionYearForm.get('yearBuiltTo')?.value!==''&&this.constructionYearForm.get('yearBuiltTo')?.value!==null){
        let fieldYearBuiltTo= parseInt(this.constructionYearForm.get('yearBuiltTo')?.value);
        if(fieldYearBuiltTo<fieldYearBuiltFrom){
          this.formService.showFormMsg("construction-year-error-message", 'Year Built To must not be earlier than Year Built From', "E");
          return true
        }
        else{
          return false
        }
      }
      else{
        return false;
      }
    }
    catch (e) {
    console.error(e);
      return false;
    }
  }
}
